export enum ScanBatchMethod {
    Barcode = "Barcode",
    Scanner = "Scanner",
}
